import { render, staticRenderFns } from "./CaptainShiftStats.vue?vue&type=template&id=31841916&scoped=true"
import script from "./CaptainShiftStats.vue?vue&type=script&lang=js"
export * from "./CaptainShiftStats.vue?vue&type=script&lang=js"
import style1 from "./CaptainShiftStats.vue?vue&type=style&index=1&id=31841916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31841916",
  null
  
)

export default component.exports